import { CommonModule } from '@angular/common'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeFormFieldModule } from 'se-fe-form-field'
import { SeFeFormFieldSelectModule } from 'se-fe-form-field-select'
import { SeFeFormServiceModule } from 'se-fe-form-service'
import { SeFeTranslationsModule } from 'se-fe-translations'
import { StateSelectComponent } from './state-select/state-select.component'


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeFormServiceModule,
    SeFeFormFieldModule,
    SeFeFormFieldSelectModule,
    SeFeTranslationsModule
  ],
  declarations: [
    StateSelectComponent
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi())
  ],
  exports: [
    StateSelectComponent
  ]
})
export class SharedUiStateSelectModule {}
